export default __webpack_public_path__ + "static/vince-ortiz-transblue-59919c9dd70e2f76ef5cd4d3865dbca1.png";